import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import {
  getPolicyImpact,
  getTimeRegistrationPolicy,
  parsePolicyError,
  putPolicyUnit,
} from 'api/requests/time-registration-policy-requests';
import { mapSaveError } from 'modules/management/time-registration-policy/helpers';
import {
  TIME_REGISTRATION_POLICY__CLEAR,
  TIME_REGISTRATION_POLICY__GET,
  TIME_REGISTRATION_POLICY__GET_IMPACT,
  TIME_REGISTRATION_POLICY__SAVE_UNIT,
  TIME_REGISTRATION_POLICY__SET_LOAD_ERROR,
  TIME_REGISTRATION_POLICY__SET_LOADING,
  TIME_REGISTRATION_POLICY__SET_UNIT,
  TIME_REGISTRATION_POLICY__SET_UNITS,
} from 'store/constants';
import {
  PolicyImpactResult,
  PolicySaveResult,
  PolicyUnit,
  ProposedUnitState,
  UnitState,
} from 'types/time-registration-policy/ITimeRegistrationPolicy';

export const setPolicyUnitsAction = createAction<UnitState[]>(TIME_REGISTRATION_POLICY__SET_UNITS);
export const setPolicyUnitAction = createAction<UnitState>(TIME_REGISTRATION_POLICY__SET_UNIT);
export const setPolicyLoadingAction = createAction<boolean>(TIME_REGISTRATION_POLICY__SET_LOADING);
export const setPolicyLoadErrorAction = createAction<boolean>(TIME_REGISTRATION_POLICY__SET_LOAD_ERROR);
export const clearPolicyAction = createAction<void>(TIME_REGISTRATION_POLICY__CLEAR);

export const getTimeRegistrationPolicyAction = createAsyncThunk(
  TIME_REGISTRATION_POLICY__GET,
  async (_: void, thunkApi) => {
    thunkApi.dispatch(setPolicyLoadingAction(true));
    thunkApi.dispatch(setPolicyLoadErrorAction(false));
    try {
      const view = await getTimeRegistrationPolicy();
      thunkApi.dispatch(setPolicyUnitsAction(view.units));
    } catch {
      thunkApi.dispatch(setPolicyLoadErrorAction(true));
    }
    thunkApi.dispatch(setPolicyLoadingAction(false));
  },
);

export const getPolicyImpactAction = createAsyncThunk(
  TIME_REGISTRATION_POLICY__GET_IMPACT,
  async ({ unit, proposed }: { unit: PolicyUnit; proposed: ProposedUnitState }): Promise<PolicyImpactResult> => {
    try {
      return { status: 'ok', impact: await getPolicyImpact(unit, proposed) };
    } catch (error) {
      return mapSaveError(parsePolicyError(error)) as PolicyImpactResult;
    }
  },
);

export const savePolicyUnitAction = createAsyncThunk(
  TIME_REGISTRATION_POLICY__SAVE_UNIT,
  async (
    { unit, expected, proposed }: { unit: PolicyUnit; expected: ProposedUnitState; proposed: ProposedUnitState },
    thunkApi,
  ): Promise<PolicySaveResult> => {
    try {
      const state = await putPolicyUnit(unit, expected, proposed);
      thunkApi.dispatch(setPolicyUnitAction(state));
      return { status: 'success', state };
    } catch (error) {
      return mapSaveError(parsePolicyError(error));
    }
  },
);
